import { Navigate } from "react-router-dom";
const Protected = ({ isHost, children }) => {
 
  if (!isHost) {
    return <Navigate to="/loadform" replace />;
  }
 
  return children;
};
export default Protected;